<template>
  <v-container>
    <v-toolbar flat class="main-header mb-6">
      <v-toolbar-title class="main-header__title">
        <h1>Collection Bags</h1>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items class="main-header__contents">
        <v-btn
          class="my-auto mx-1 radius-12"
          color="success"
          to="collection-bags/create"
        >
          <v-icon>mdi-plus-circle</v-icon>
          <span class="mx-2">New Bag</span>
        </v-btn>
      </v-toolbar-items>
    </v-toolbar>
    <hr class="mb-6" />
    <v-data-table
      :headers="headers"
      :loading="loadingDataTable"
      :items="collectionBags"
      :mobile-breakpoint="zero"
      :items-per-page="200"
      hide-default-footer
      class="table teams"
    >
      <template v-slot:item="{ item, index }">
        <tr class="table__row">
          <td class="table__cell name text-center">
            {{ item.display_name || "---" }}
          </td>
          <td class="table__cell text-center transparent-field">
            <v-checkbox
              v-model="item.allow_custom_collection"
              color="warning"
              @change="bagVisiblity(item)"
            ></v-checkbox>
          </td>
          <td class="table__cell text-center">
            <router-link :to="{ name: 'bagSources', query: { bag: item.id } }">
              <v-icon>mdi-open-in-app</v-icon>
            </router-link>
          </td>
          <td class="table__cell text-center">
            <router-link
              :to="{ name: 'phaseQuestions', query: { bag: item.id } }"
            >
              <v-icon>mdi-open-in-app</v-icon>
            </router-link>
          </td>

          <td class="table__cell text-center">
            <router-link
              :to="{ name: 'collectionBagsEdit', params: { id: item.id } }"
              class="hovering mr-3 edit"
            >
              <v-icon small>mdi-pencil</v-icon><br />
              Edit
            </router-link>
            <span @click="handleDelete(item, index)" class="hovering delete">
              <v-icon small>mdi-delete</v-icon><br />
              Delete
            </span>
          </td>
        </tr>
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import TableHeaders from "@/helpers/TableHeaders";
import { IndexData, UpdateData, DeleteData } from "@/helpers/apiMethods";
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      zero: 0,
      appData: {},
      dialog: false,
      priority: false,
      loading: false,
      headers: [],
      collectionBags: [],
      appTypecollectionBags: [],
      loadingDataTable: false
    };
  },
  computed: {
    ...mapGetters({
      permissions: "permissions"
    })
  },
  created() {
    this.createTableHeaders();
    this.indexCollectionBags();
  },
  methods: {
    indexCollectionBags() {
      this.loadingDataTable = true;
      IndexData({ reqName: `hr/collection-bags` })
        .then(res => {
          const { data } = res.data;
          this.collectionBags = data;
          this.loadingDataTable = false;
        })
        .catch(() => {})
        .finally(() => {});
    },
    createTableHeaders() {
      const headersList = [
        "Display Name",
        "Allow Custom Collection",
        "Sources",
        "Questions",
        "Actions"
      ];
      this.headers = TableHeaders(headersList);
    },
    bagVisiblity(item) {
      UpdateData({
        reqName: `hr/collection-bags`,
        data: { visible: item.allow_custom_collection, _method: "PUT" },
        id: item.id
      })
        .then(() => {})
        .catch(() => {})
        .finally(() => {});
    },
    handleDelete({ id }, index) {
      this.popUp().then(value => {
        if (!value.dismiss) {
          DeleteData({
            reqName: `/hr/collection-bags`,
            id: id
          })
            .then(() => {
              this.collectionBags.splice(index, 1);
            })
            .catch(() => {});
        }
      });
    }
  }
};
</script>
